import { render, staticRenderFns } from "./EditNewsHeader.vue?vue&type=template&id=3ed8f737&scoped=true&"
import script from "./EditNewsHeader.vue?vue&type=script&lang=ts&"
export * from "./EditNewsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./EditNewsHeader.vue?vue&type=style&index=0&id=3ed8f737&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed8f737",
  null
  
)

export default component.exports